const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

type Config = {
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
};

let newWorker: ServiceWorker | null = null;
let updateAvailable = false;

// Create a custom event for update notifications
export const UPDATE_AVAILABLE_EVENT = 'serviceWorkerUpdateAvailable';

export function register(config?: Config) {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
      } else {
        registerValidSW(swUrl, config);
      }

      // Add listener for skipWaiting message from service worker
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // When the controller changes (after skipWaiting), reload the page
        window.location.reload();
      });
    });
  }
}

function registerValidSW(swUrl: string, config?: Config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.addEventListener('updatefound', () => {
        newWorker = registration.installing;
        if (newWorker == null) {
          return;
        }

        newWorker.addEventListener('statechange', () => {
          if (newWorker && newWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              updateAvailable = true;
              
              // Dispatch a custom event for update notification
              window.dispatchEvent(new Event(UPDATE_AVAILABLE_EVENT));
              
              // Execute the callback if provided
              if (config?.onUpdate) {
                config.onUpdate(registration);
              }
              
              // For mobile users, you might want to show a more persistent notification
              // This could be a banner at the top of the app
              showUpdateBanner();
            } else {
              // Content is cached for offline use
              if (config?.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        });
      });
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

// Simple function to create and show an update banner for mobile users
function showUpdateBanner() {
  // Check if banner already exists
  if (document.getElementById('update-banner')) return;
  
  const banner = document.createElement('div');
  banner.id = 'update-banner';
  banner.style.position = 'fixed';
  banner.style.top = '0';
  banner.style.left = '0';
  banner.style.right = '0';
  banner.style.backgroundColor = '#4caf50';
  banner.style.color = 'white';
  banner.style.padding = '16px';
  banner.style.textAlign = 'center';
  banner.style.zIndex = '9999';
  banner.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
  
  banner.innerHTML = `
    <p style="margin: 0; font-weight: bold;">New version available!</p>
    <button id="update-app-btn" style="margin-top: 8px; padding: 8px 16px; background: white; color: #4caf50; border: none; border-radius: 4px; cursor: pointer;">
      Update Now
    </button>
  `;
  
  document.body.appendChild(banner);
  
  document.getElementById('update-app-btn')?.addEventListener('click', () => {
    applyUpdate();
  });
}

function checkValidServiceWorker(swUrl: string, config?: Config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
//console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

export function isUpdateAvailable(): boolean {
  return updateAvailable;
}

export function applyUpdate() {
  if (newWorker) {
    newWorker.postMessage({ type: 'SKIP_WAITING' });
    // The page will reload via the controllerchange event listener
  }
} 